"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelAutoComplete = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var swr_1 = tslib_1.__importDefault(require("swr"));
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var context_1 = require("../../context");
var Container = (0, styled_components_1.default)(antd_1.Select)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  min-width: 170px !important;\n"], ["\n  min-width: 170px !important;\n"])));
var AutoComplete = function (_a) {
    var url = _a.url, httpClient = _a.httpClient, label = _a.label, mode = _a.mode, valueKey = _a.valueKey, labelKey = _a.labelKey, defaultValue = _a.defaultValue, onFilter = _a.onFilter;
    var _b = (0, react_1.useState)(""), search = _b[0], setSearch = _b[1];
    var u = new URL(url);
    if (search) {
        u.searchParams.append("search", search);
    }
    var _c = (0, swr_1.default)(u.href, httpClient, { revalidateOnFocus: false }), response = _c.data, error = _c.error;
    var options = response === null || response === void 0 ? void 0 : response.map(function (row) {
        return {
            value: row[valueKey],
            label: row[labelKey],
        };
    });
    var keyedOptions = (0, lodash_1.keyBy)(options, "value");
    return (react_1.default.createElement(Container, { getPopupContainer: function (trigger) { return trigger.parentNode; }, mode: mode, placeholder: label, options: options, showSearch: true, showArrow: true, allowClear: true, showAction: ["click"], onSearch: (0, lodash_1.debounce)(function (v) { return setSearch(v); }, 500), onClear: function () {
            setSearch("");
        }, onChange: function (value) {
            var label = value.map(function (v) { return keyedOptions[v].label; });
            onFilter(value, label);
        }, filterOption: false, loading: !error && !response, className: "auto-complete-select", defaultValue: defaultValue, maxTagCount: "responsive" }));
};
var LabelAutoComplete = function (_a) {
    var _b, _c;
    var filter = _a.filter, onAppend = _a.onAppend;
    var ctx = (0, context_1.useTableContext)();
    var autoComplete = filter === null || filter === void 0 ? void 0 : filter.autoComplete;
    var url = new URL(((_b = filter === null || filter === void 0 ? void 0 : filter.autoComplete) === null || _b === void 0 ? void 0 : _b.url) || "");
    url.searchParams.append("".concat(autoComplete === null || autoComplete === void 0 ? void 0 : autoComplete.valueKey, "__in"), ((_c = filter.value) === null || _c === void 0 ? void 0 : _c.toString()) || "");
    var _d = (0, swr_1.default)((0, lodash_1.isEmpty)(filter === null || filter === void 0 ? void 0 : filter.label) && url.href, autoComplete === null || autoComplete === void 0 ? void 0 : autoComplete.client), data = _d.data, error = _d.error;
    var label = autoComplete && data
        ? data === null || data === void 0 ? void 0 : data.map(function (row) {
            return row[autoComplete.labelKey];
        }).join(", ")
        : "";
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (!(0, lodash_1.isEmpty)(label)) {
            (_b = (_a = ctx.filtersObject) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (f) {
                if (f.key === filter.key) {
                    f.label = label;
                }
            });
            // @ts-ignore
            onAppend(tslib_1.__spreadArray([], ctx.filtersObject.data, true));
        }
    }, [data]);
    if (filter === null || filter === void 0 ? void 0 : filter.label) {
        return react_1.default.createElement("span", null, filter === null || filter === void 0 ? void 0 : filter.label);
    }
    if (error) {
        return react_1.default.createElement("span", null, filter.value);
    }
    if (error === undefined && data === undefined) {
        return react_1.default.createElement(antd_1.Spin, { size: 'small' });
    }
    return react_1.default.createElement("span", null, label);
};
exports.LabelAutoComplete = LabelAutoComplete;
exports.default = AutoComplete;
var templateObject_1;
//# sourceMappingURL=auto-complete.js.map